import {
  VuexModule,
  Module,
  Mutation
} from 'vuex-module-decorators'

export type UIState = {
  isMobile: boolean
}

export type UIModuleState = {
  isMobile: boolean
  isDrawerOpened: boolean
  navBarHeight: number
}

@Module({ name: 'UI', namespaced: true })
export default class UI extends VuexModule implements UIState {
  // ➊ State

  private uiModuleState: UIModuleState = {
    isMobile: false,
    isDrawerOpened: false,
    navBarHeight: 0
  }

  // ➋ Getters

  public get isMobile(): boolean {
    return this.uiModuleState.isMobile
  }

  public get isDrawerOpened(): boolean {
    return this.uiModuleState.isDrawerOpened
  }

  public get navBarHeight(): number {
    return this.uiModuleState.navBarHeight
  }

  // ➌ Mutations

  @Mutation
  public SET_IS_MOBILE(val: boolean) {
    this.uiModuleState.isMobile = val
  }

  @Mutation
  public SET_DRAWER_OPEN(val: boolean) {
    this.uiModuleState.isDrawerOpened = val
  }

  @Mutation
  public SET_NAV_HEIGHT(val: number) {
    this.uiModuleState.navBarHeight = val
  }
}
